import { ACO, getPitStopTimes } from "./service.js";

export class ELMS extends ACO {
  constructor(...args) {
    super(
      'data.europeanlemansseries.com',
      'European Le Mans Series',
      ...args
    );
  }

  postProcessCar(car, stints, parameters) {
    const classIdx = 2;
    const pitIndex = 19;
    const clazz = car[classIdx];
    if (clazz === 'LMP3' && parameters.LMP3_MIN_PIT_TIME_SECONDS) {
      const pitTimes = getPitStopTimes(stints[car[0]]);
      const timedStops = pitTimes.filter(t => t >= parameters.LMP3_MIN_PIT_TIME_SECONDS);
      const hasMetObligations = timedStops.length >= parameters.LMP3_MIN_PIT_TIME_COUNT;
      if (hasMetObligations) {
        car[pitIndex][1] = 'green';
      }
      else if (timedStops.length > 0) {
        car[pitIndex][1] = 'yellow';
      }
      else {
        car[pitIndex][1] = 'red';
      }
    }
  }
};

ELMS.regex = /live\.europeanlemansseries\.com/;

ELMS.parametersSpec = {
  LMP3_MIN_PIT_TIME_SECONDS: {
    description: 'Minimum time of LMP3 statutory pit stops, in seconds.',
    label: 'LMP3 minimum pit time',
    type: 'number',
    minimum: 0,
    unit: 's'
  },
  LMP3_MIN_PIT_TIME_COUNT: {
    description: `Number of times each entrant must make a stop of the required
    duration. Pit count indicator will be red until this is achieved, yellow if
    at least one long stop has been made but with more owed, and green once
    a competitor has fulfilled their obligations.`,
    label: 'LMP3 mandatory pit count',
    type: 'number',
    minimum: 0
  }
}
